import React from "react"
import "./ModalThemeSong.scss"

const ModalThemeSong = ({ showYoutubeModal, hideYoutubeModal, playerRef }) => {
  return (
    <div className={`modal-theme-song ${showYoutubeModal ? "show" : ""}`}>
      <button
        className="modal-bg"
        aria-label="close"
        onClick={hideYoutubeModal}
      ></button>
      <button
        className="modal-close-button"
        aria-label="close"
        onClick={hideYoutubeModal}
      ></button>
      <div id="player" ref={playerRef}></div>
    </div>
  )
}

export default ModalThemeSong
